/**
 * Stat Card component for dashboard metrics
 */

import { Card, CardContent } from './card';
import { Icon, type IconName } from './icon';
import { cn } from '@/lib/utils';

export interface StatCardProps {
  labelKey?: string;
  label?: string;
  value: string | number;
  change?: string;
  icon?: IconName;
  className?: string;
  testId?: string;
}

export function StatCard({
  labelKey,
  label,
  value,
  change,
  icon,
  className,
  testId,
}: StatCardProps) {
  const isPositive = change?.startsWith('+');
  const isNegative = change?.startsWith('-');

  return (
    <Card className={cn('', className)} data-testid={testId}>
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <p className="text-sm font-medium text-muted-foreground">
              {label || labelKey}
            </p>
            <p className="text-2xl font-bold">{value}</p>
            {change && (
              <p
                className={cn(
                  'text-xs',
                  isPositive && 'text-green-600 dark:text-green-400',
                  isNegative && 'text-red-600 dark:text-red-400',
                  !isPositive && !isNegative && 'text-muted-foreground'
                )}
              >
                {change}
              </p>
            )}
          </div>
          {icon && (
            <div className="rounded-full bg-muted p-3">
              <Icon name={icon} className="h-5 w-5 text-primary" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
